import { URL_SERVICIOS, URL_MODBUS, URL_POS, URL_SOCKET, URL_NODE } from '../app/config/config';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  URL_SERVICIOS,
  URL_MODBUS,
  URL_POS,
  URL_SOCKET,
  FLAG_AREA: true,
  TIME_REFRESH: 1000 * 60 * 60 * 24 * 7,  // cada 30 dias,,
  URL_NODE: URL_NODE
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

